/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.rules.updowngrade.controllers', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.membership',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.common.factory.slider',
  'acme.view.application.membership.benefits.modals.add.controllers',
  'acme.common.service.themesHelper'
])

.controller('MembershipRulesUpdowngradeController', ['$scope', '$uibModal', '$timeout', 'ApiService', 'HelpersService', 'MembershipService', 'GridStateFactory', 'NoticeFactory', 'SliderFactory', 'ThemesHelperService', function($scope, $uibModal, $timeout, ApiService, HelpersService, MembershipService, GridStateFactory, NoticeFactory, SliderFactory, ThemesHelperService) {

    $scope.membershipRulesUpdowngrade = {

      model: {
        sourceMembershipLevel: {},
        eligibleMembershipLevels: []
      },

      slideStepPercentage : '100%',

      containerStepPercentage : '100%',

      sliderSteps: [
        {
          stepName: 'auxiliaryEnable',
          data: 'categoryTypes',
          sliderSteps: [
            {
              stepName: 'categoryTypes',
              name: 'Choose a category',
              data: [
                {
                  stepName: 'individualAndFamily',
                  name: 'Individual & Family',
                  next: 'levelTypes',
                  id: 'individualAndFamily'
                },
                {
                  stepName: 'organization',
                  name: 'Organizations',
                  next: 'level',
                  id: 'organization'
                }
              ]
            },
            {
              stepName: 'levelTypes',
              name: 'Choose a level type',
              data: [
                {
                  stepName: 'regular',
                  name: 'Regular',
                  next: 'level',
                  id: 'regular'
                },
                {
                  stepName: 'auxiliary',
                  name: 'Auxiliary',
                  next: 'levelGroups',
                  id: 'auxiliary'
                }
              ]
            },
            {
              stepName: 'levelGroups',
              name: 'Choose a group type',
              data: '',
              callback: function() {
                $scope.membershipRulesUpdowngrade.getLevelGroups();
              }
            },
            {
              stepName: 'level',
              name: 'Choose a level type',
              data: '',
              callback: function() {
                $scope.membershipRulesUpdowngrade.getLevels();
              }
            }
          ]
        },
        {
          stepName: 'auxiliaryDisabled',
          data: 'categoryTypes',
          sliderSteps: [
            {
              stepName: 'categoryTypes',
              name: 'Choose a category type',
              data: [
                {
                  stepName: 'individualAndFamily',
                  name: 'Individual & Family',
                  next: 'level',
                  id: 'individualAndFamily'
                },
                {
                  stepName: 'organization',
                  name: 'Organizations',
                  next: 'level',
                  id: 'organization'
                }
              ]
            },
            {
              stepName: 'level',
              name: 'Choose a level type',
              data: '',
              callback: function() {
                $scope.membershipRulesUpdowngrade.getLevels();
              }
            }
          ]
        }
      ],

      company: ThemesHelperService.getCompany(),
      dragSections: {
        ineligible: [],
        upgrade: [],
        downgrade: []
      },

      slideStep: '',

      mode: 'view',
      addModal: {},
      categories: [],

      selectedCategoryType: false,
      selectedLevelType: false,
      selectedCategory: false,

      isSaving: false,
      categoriesLoaded: false,

      gridState: new GridStateFactory(),
      notice: new NoticeFactory(),
      slider: new SliderFactory(),
      stepHistory: [],
      isAuxEnabled: false,
      isAuxiliary:false,

      categoryName: '',

      currentGroup: '',

      init: function() {

        $scope.$emit('Application::contentTitleChange', {
          title: 'Membership Upgrade / Downgrade'
        });

        this.gridState.updateGridState(1, -1, 'name', 'asc');
        if(this.company && this.company.auxiliaryMembership) {
          this.isAuxEnabled = this.company.auxiliaryMembership;
        }
        this.slider.init(this.sliderSteps);
        this.slider.start(this.isAuxEnabled ? 'auxiliaryEnable' : 'auxiliaryDisabled');
      },

      isMode: function(mode) {
        return (this.mode === mode);
      },

      setMode: function(mode) {
        this.mode = mode;
      },

      edit: function() {
        this.cache = angular.copy(this.model);
        this.setMode('edit');
      },

      cancel: function() {
        this.setMode('view');
      },

      update: function() {
        this.isSaving = true;
        if (!this.model.id) {
          this.create();
        } else {
          this.prepare();
          ApiService.membership.eligibility.update(this.model).then(this.success.update, this.error.update);
        }
      },

      create: function() {
        this.prepare();
        ApiService.membership.eligibility.create(this.model).then(this.success.create, this.error.create);
      },

      getLevelGroups: function() {
        ApiService.membership.categories.collection.list(HelpersService.getPaginator({sortField: 'name', sortDirection: 'asc'})).then(this.success.getLevelGroups, this.error.getLevelGroups);
      },

      getLevels: function() {

        var props = this.gridState.getGridState();
        props = HelpersService.getPaginator({ sortField: 'name', sortDirection: 'asc' });
        props.salesChannels = 'online,insideSalesIndividual,pointOfSale,reseller,manualEntry,customerRep';
        props.isPublished = '1';
        props.summarize = '1';
        props.pageSize = '-1';
        props.auxiliary = this.isAuxiliary ? '1' : '0';
        props.membershipLevelGroup = this.selectedCategoryType;
        if (this.currentGroup && this.currentGroup.id) {
          props.collectionId = this.currentGroup.id;
          if (props.excludeLevelsWithACollection) {
            delete(props.excludeLevelsWithACollection);
          }
        } else {
          props.collectionId = '';
          props.excludeLevelsWithACollection = '1';
        }

        ApiService.membership.categories.list(props).then(this.success.getLevels, this.error.getLevels);

      },

      getEligibility: function(categoryId) {
        this.dragSections = {
          ineligible: [],
          upgrade: [],
          downgrade: []
        };

        ApiService.membership.eligibility.detail(categoryId).then(this.success.getEligibility, this.error.getEligibility);
      },

      next: function(stepName) {
        this.categoriesLoaded = false;
        this.slider.getStep(stepName);
        this.updateSlideStep(this.slider.stepHistory.length - 1);
      },

      unselectCategoryType: function(stepName) {
        this.selectedCategoryType = false;
        this.selectedCategory = false;
        this.currentGroup = false;
        this.categories = [];
        this.slider.back(stepName);
        this.updateSlideStep(this.slider.stepHistory.length - 1);
      },

      selectCategoryType: function(categoryType) {

        switch (categoryType.stepName) {
          case 'individualAndFamily' :
          case 'organization' :
            this.isAuxiliary = false;
            this.selectedCategoryType = categoryType.stepName;
            break;
          case 'auxiliary':
            this.isAuxiliary = true;
            break;
          case 'regular':
            this.isAuxiliary = false;
            break;
          case 'levelGroup':
            this.currentGroup = categoryType;
            break;
        }

        if (categoryType.next) {
          this.next(categoryType.next);
        }

        if (this.categoriesLoaded) {
          this.selectCategory(categoryType);
        }
      },

      selectCategory: function(category) {
        if (category) {
          this.selectedCategory = category;
          this.getEligibility(category.id);
        }
      },

      showBenefits: function(category) {

        var self = $scope.membershipRulesUpdowngrade;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/membership/benefits/modals/add/add.tpl.html',
          size: 'md',
          controller: 'MembershipBenefitsModalsAddController',
          resolve: {
            editable: function() {
              return false;
            },
            currentBenefits: function() {
              return category.benefits;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(angular.noop, angular.noop);

      },

      moveUp: function() {},

      moveGroup: function(direction, category, index) {
        var from,
            to,
            method;


        switch(direction) {
          case 'down':
            if (!category._type || category._type === 'ineligible') {
              from = 'ineligible';
              to = 'upgrade';
            }else if (category._type === 'upgrade') {
              from = 'upgrade';
              to = 'downgrade';
            }else if (category._type === 'downgrade') {
              from = 'downgrade';
              to = 'ineligible';
            }
            method = 'unshift';
            break;
          case 'up':
            if (!category._type || category._type === 'ineligible') {
              from = 'ineligible';
              to = 'downgrade';
            }else if (category._type === 'upgrade') {
              from = 'upgrade';
              to = 'ineligible';
            }else if (category._type === 'downgrade') {
              from = 'downgrade';
              to = 'upgrade';
            }
            method = 'push';
            break;
        }

        category._type = to;
        console.log(to);
        this.dragSections[to][method](this.dragSections[from].splice(index, 1)[0]);

      },

      updateSlideStep: function(step) {
        this.slideStep = 'slide' + step;
        this.slideStepPercentage = (100 / (step + 1)) + '%';
        this.containerStepPercentage = (100 * (step + 1)) + '%';
      },

      findEligibleMembershipLevelType: function(type) {
        var i, ii,
            r = false;

        if (this.model.eligibleMembershipLevels instanceof Array) {
          for (i=0,ii=this.model.eligibleMembershipLevels.length;i<ii;i++) {
            if (this.model.eligibleMembershipLevels[i].type === type) {
              r = {
                index: i,
                level: this.model.eligibleMembershipLevels[i]
              };
              break;
            }
          }
        }

        return r;
      },

      prepare: function() {

        var i, ii,
            found,
            level;

        this.model.sourceMembershipLevel = angular.copy(this.selectedCategory);

        found = this.findEligibleMembershipLevelType('upgrade');

        if (found) {
          this.model.eligibleMembershipLevels[found.index].targetLevels = [];
        }

        for (i=0,ii=this.dragSections.upgrade.length;i<ii;i++) {
          level = angular.copy(this.dragSections.upgrade[i]);
          // Cleanup internal values
          level._type = null;
          delete level._type;

          found = this.findEligibleMembershipLevelType('upgrade');

          if (found) {
            this.model.eligibleMembershipLevels[found.index].targetLevels.push(level);
          }else {
            this.model.eligibleMembershipLevels.push({
              type: 'upgrade',
              targetLevels: [ level ]
            });
          }
        }

        found = this.findEligibleMembershipLevelType('downgrade');

        if (found) {
          this.model.eligibleMembershipLevels[found.index].targetLevels = [];
        }

        for (i=0,ii=this.dragSections.downgrade.length;i<ii;i++) {
          level = angular.copy(this.dragSections.downgrade[i]);
          // Cleanup internal values
          level._type = null;
          delete level._type;

          found = this.findEligibleMembershipLevelType('downgrade');

          if (found) {
            this.model.eligibleMembershipLevels[found.index].targetLevels.push(level);
          }else {
            this.model.eligibleMembershipLevels.push({
              type: 'downgrade',
              targetLevels: [ level ]
            });
          }
        }

      },

      process: function(eligible) {
        var i, ii,
            j, jj,
            exists,
            r = {
              upgrade: [],
              downgrade: [],
              ineligible: []
            };

        if (eligible) {
          // Already setup
          if (eligible.eligibleMembershipLevels instanceof Array) {
            for (i=0,ii=eligible.eligibleMembershipLevels.length;i<ii;i++) {
              if (eligible.eligibleMembershipLevels[i].type === 'upgrade' &&
                  eligible.eligibleMembershipLevels[i].targetLevels.length) {
                r.upgrade = r.upgrade.concat(eligible.eligibleMembershipLevels[i].targetLevels.slice(0));
              }else if (eligible.eligibleMembershipLevels[i].type === 'downgrade' &&
                        eligible.eligibleMembershipLevels[i].targetLevels.length) {
                r.downgrade = r.downgrade.concat(eligible.eligibleMembershipLevels[i].targetLevels.slice(0));
              }
            }
          }

          for (i=0,ii=this.categories.length;i<ii;i++) {
            if (this.selectedCategory.id !== this.categories[i].id) {

              this.categories[i]._type = 'ineligible';
              exists = false;

              for (j=0,jj=r.upgrade.length;j<jj;j++) {
                r.upgrade[j]._type = 'upgrade';
                if (this.categories[i].id === r.upgrade[j].id) {
                  exists = true;
                  break;
                }
              }

              for (j=0,jj=r.downgrade.length;j<jj;j++) {
                r.downgrade[j]._type = 'downgrade';
                if (this.categories[i].id === r.downgrade[j].id) {
                  exists = true;
                  break;
                }
              }

              if (!exists) {
                r.ineligible.push(angular.copy(this.categories[i]));
              }
            }
          }

          //eligible.sourceMembershipLevel
        }else{
          // New setup
          for (i=0,ii=this.categories.length;i<ii;i++) {
            if (this.selectedCategory.id !== this.categories[i].id) {
              this.categories[i]._type = 'ineligible';
              r.ineligible.push(angular.copy(this.categories[i]));
            }
          }
        }

        return r;
      },

      success: {
        init: function(response) {},

        update: function(response) {
          var self = $scope.membershipRulesUpdowngrade;
          self.isSaving = false;

          self.notice.showSuccessMessages([
            { message: 'Successfully updated' }
          ]);

          $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);
        },

        create: function(response) {
          var self = $scope.membershipRulesUpdowngrade;
          self.model.id = response.data.payload.id;
          self.isSaving = false;

          self.notice.showSuccessMessages([
            { message: 'Successfully updated' }
          ]);

          $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);

        },

        getLevelGroups: function(response) {

          var self = $scope.membershipRulesUpdowngrade;

          self.slider.currentStep.data = response.data.payload.list;
          self.slider.currentStep.data.forEach(function (dataItem) {
            dataItem.next = 'level';
            dataItem.stepName = 'levelGroup';
          });

          self.slider.currentStep.data.push({
            name: 'None',
            next: 'level',
            id: 'none'
          });

        },

        getLevels: function(response) {
          var self = $scope.membershipRulesUpdowngrade;
          self.categories = response.data.payload.list;

          self.slider.currentStep.data = self.categories;
          if (!this.categoriesLoaded && self.categories.length && self.categories[0]) {
            self.selectCategory(self.categories[0]);
          }
          self.categoriesLoaded = true;
        },

        getEligibility: function(response) {
          var self = $scope.membershipRulesUpdowngrade;
          if (response.data.payload.id) {
            self.model.id = response.data.payload.id;
            self.dragSections = self.process(response.data.payload);
          }else{
            self.model.id = null;
            delete(self.model.id);
            self.dragSections = self.process();
          }
        }
      },

      error: {
        init: function(response) {},
        update: function(response) {
          var self = $scope.membershipRulesUpdowngrade;

          self.isSaving = false;

          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },

        create: function(response) {
          var self = $scope.membershipRulesUpdowngrade;

          self.isSaving = false;

          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },

        getLevelGroups: function(response) {
          var self = $scope.membershipRulesUpdowngrade;
          self.categoriesLoaded = false;
        },

        getLevels: function(response) {
          var self = $scope.membershipRulesUpdowngrade;
          self.categoriesLoaded = false;
        },

        getEligibility: function(response) {
          var self = $scope.membershipRulesUpdowngrade;
          self.model.id = null;
          delete(self.model.id);
          if (response.status === 404) {
            self.dragSections = self.process();
          }
        }
      },

      onDrop: function($event, $data, array, categoryType, index) {
        var i, ii,
            self = $scope.membershipRulesUpdowngrade;

        for (i=0,ii=self.dragSections[$data._type].length;i<ii;i++) {
          if (self.dragSections[$data._type][i].id === $data.id) {
            if (index !== undefined) {
              array.splice(index, 0, self.dragSections[$data._type].splice(i, 1)[0]);
              array[index]._type = categoryType;
            }else{
              array.unshift(self.dragSections[$data._type].splice(i, 1)[0]);
              array[0]._type = categoryType;
            }
            break;
          }
        }
      },

      onDropSuccess: function($event, index, array) {
        // TODO: May need to remove
      }

    };

    $scope.membershipRulesUpdowngrade.init();

}]);